module.exports = __webpack_public_path__ + "img/C4.c0a2c999.png";